import React, { useState } from "react";

function QuestionsExpandable({ Qu, An }) {
  const [isToggled, setIsToggled] = useState(false);
  return (
    <section className="question-container" onClick={() => setIsToggled(!isToggled)}>
      <h3 className="centered-subtitle">Q: {Qu}<i className="bi bi-chevron-down" style={{ transition: "0.2s all ease", position: "absolute", right: "1rem", top: "1rem", transform: `${isToggled ? "rotate(180deg)" : "rotate(0deg)"}` }}></i></h3>
      <span className={`centered-subtitle ${isToggled ? "toggled-question" : "untoggled-question"}`}><b>A: </b>{An}</span>
    </section>
  )
}
function FAQ() {
  return (
    <section className="faq-container">
      <h1 className="centered-subtitle">FAQ</h1>
      <article className="flex-card-containers-faq">
        <QuestionsExpandable
          Qu="Where do you source your crystals and botanicals from?"
          An="We carefully source our crystals, botanicals, and teas from reputable suppliers around the world. Our focus is on quality and authenticity, ensuring that each product meets our standards for aesthetics, purity, and sustainability."
        />
        <QuestionsExpandable
          Qu="Do your crystals come with any spiritual or metaphysical claims?"
          An="We love raw crystals for their beauty and unique formations. While some people believe in their metaphysical properties, we leave that interpretation completely up to you. Whether you're here for energy work, aesthetics, or collecting, we respect all perspectives!"
        />
        <QuestionsExpandable
          Qu="What types of botanicals and teas do you offer?"
          An="We specialize in yerba mate, herbal blends, and premium teas, along with incense and botanical products for relaxation, focus, and well-being. Our collection is constantly growing, so check back often for new additions!"
        />
        <QuestionsExpandable
          Qu="What is yerba mate, and how do I prepare it?"
          An="Yerba mate is a traditional South American drink known for its smooth energy boost and rich antioxidants. To prepare it traditionally:
          1. Fill your mate gourd about ⅔ full with yerba mate. 2. Tilt the gourd to create a slope and pour a little cold water at the base. 3. Insert the bombilla (metal straw) into the slope. 4. Pour hot (not boiling) water into the low end and enjoy!"
        />
        <QuestionsExpandable
          Qu="Do you ship internationally?"
          An="Currently, we primarily ship within the United States, but we're working on expanding our shipping options. If you're outside the U.S., feel free to contact us, and we'll see what we can do!"
        />
        <QuestionsExpandable
          Qu="How do I care for my crystals?"
          An="Crystals are natural formations, and some may be more delicate than others. General care tips include keeping them away from direct sunlight (some crystals may fade), using gentle cleaning methods (warm water and a soft cloth for most stones), and, if you're into energy cleansing, you can use smoke, sound, or moonlight—but we personally just like keeping them dust-free and displayed beautifully!"
        />
        <QuestionsExpandable
          Qu="Do you accept returns or exchanges?"
          An="We accept returns and exchanges within 15 days of receiving your order, provided the items are unused and in their original condition. However, due to the nature of crystals and botanicals, some products (like tea and incense) may be final sale for hygiene reasons."
        />
        <QuestionsExpandable
          Qu="Can I request a specific crystal or custom order?"
          An="Yes! If you're looking for a specific type of raw crystal, bracelet, or botanical blend, let us know! We may be able to source it for you or offer a custom recommendation based on our inventory."
        />
        <QuestionsExpandable
          Qu="How can I contact you?"
          An="You can reach us via email or social media! We’re always happy to help with questions, recommendations, or special requests. Check our Contact Us page for details."
        />
      </article>
    </section>
  );
}

export default FAQ;